import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const EmpresaPage = lazy(() => import("../pages/empresa/page"));
const ServiciosPage = lazy(() => import("../pages/servicios/page"));
const FaqPage = lazy(() => import("../pages/faq/page"));
const ContactoPage = lazy(() => import("../pages/contacto/page"));

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-8 h-8 border-2 border-[#ff0000] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<PageLoader />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/empresa",
    element: (
      <Suspense fallback={<PageLoader />}>
        <EmpresaPage />
      </Suspense>
    ),
  },
  {
    path: "/servicios",
    element: (
      <Suspense fallback={<PageLoader />}>
        <ServiciosPage />
      </Suspense>
    ),
  },
  {
    path: "/faq",
    element: (
      <Suspense fallback={<PageLoader />}>
        <FaqPage />
      </Suspense>
    ),
  },
  {
    path: "/contacto",
    element: (
      <Suspense fallback={<PageLoader />}>
        <ContactoPage />
      </Suspense>
    ),
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
